<template>
    <div class="c-brands">
        <div class="c-brands__item" v-for="(brand,key) in brands" :key="brand.id+'b'" v-on:click="selectBrand(brand.id);selectedKey = key" v-bind:class="isBrandSelected(key)">
            <img :src="brand.image" :alt="brand.name">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            selectedID:null,
            selectedKey:null,
            brands:[
                {
                    name:'Volkswagen',
                    id:1,
                    image:require('../assets/images/logo-vw.jpg')
                },
                {
                    name:'Audi',
                    id:2,
                    image:require('../assets/images/logo-audi.jpg')
                },
                {
                    name:'Seat',
                    id:4,
                    image:require('../assets/images/logo-seat.jpg')
                },
                {
                    name:'Skoda',
                    id:4,
                    image:require('../assets/images/skoda_logo_new.svg')
                },
                {
                    name:'Cupra',
                    id:4,
                    image:require('../assets/images/cupra.png')
                },
                {
                    name:'Volkswagen Dostawcze',
                    id:5,
                    image:require('../assets/images/logo-vwd.jpg')
                }

            ]
        }
    },
    methods:{
        selectBrand(id){
            this.selectedID = id;
            this.$emit('selectBrand',this.selectedID);
            this.$emit('isValid',true);
        },
        isBrandSelected(key){
            return this.selectedKey == key?'c-brands__item--selected':''
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-brands{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        @media (min-width:960px) {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-around;
            padding-left: 4rem;
        }
        &__item{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50%;
            padding: 1rem;
            cursor: pointer;
            position: relative;
            @media(max-width:600px){
                width: 100%;
            }
            &__img{
                max-width: 100%;
                height: auto;
            }
            &::after{
                content: ' ';
                display: block;
                position: absolute;
                top: -1rem;
                left: -1rem;
                right: -1rem;
                bottom: -1rem;
                border: 1px solid $darkLazuri;
                border-radius: .5rem;
                transition: all .5s;
                opacity: 0;
            }
            &--selected{
                &::after{
                    top: .25rem;
                    left: .25rem;
                    right: .25rem;
                    bottom: .25rem;
                    opacity: 1;
                }
            }
        }
    }
</style>
